import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getAnalytics, type Analytics } from 'firebase/analytics'

import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { connectDatabaseEmulator, getDatabase } from 'firebase/database'
import { connectStorageEmulator, getStorage } from 'firebase/storage'
import { logger } from '../helpers/logger'

const getEnv = (key: string) => {
    const value = process.env[key]
    return typeof value === 'string' && value.trim() !== '' ? value : undefined
}

const useEmulators = process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true'
const isTest = process.env.NODE_ENV === 'test'
const projectId = getEnv('REACT_APP_FIREBASE_PROJECT_ID') || 'spark-web-test'
const databaseURL =
    getEnv('REACT_APP_FIREBASE_DATA_BASE_URL') ||
    (isTest || useEmulators
        ? `http://127.0.0.1:9000?ns=${projectId}-default-rtdb`
        : undefined)

export const FIREBASE_CONFIG = {
    apiKey: getEnv('REACT_APP_FIREBASE_API_KEY'),
    authDomain: getEnv('REACT_APP_FIREBASE_AUTH_DOMAIN'),
    databaseURL,
    projectId,
    storageBucket: getEnv('REACT_APP_FIREBASE_STORAGE_BUCKET'),
    messagingSenderId: getEnv('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
    appId: getEnv('REACT_APP_FIREBASE_APP_ID'),
    measurementId: getEnv('REACT_APP_FIREBASE_MEASUREMENT_ID'),
}

export const app = initializeApp(FIREBASE_CONFIG)
export const db = getDatabase(app)
export const auth = getAuth(app)
const shouldInitializeAnalytics =
    typeof window !== 'undefined' && !isTest
export const analytics = shouldInitializeAnalytics
    ? getAnalytics(app)
    : ({} as Analytics)
const functionsRegion = useEmulators ? undefined : 'asia-southeast1'
export const functions = getFunctions(app, functionsRegion)

// Configurations for connecting Firebase Emulators
// const functions = getFunctions(app);

if (useEmulators || isTest) {
    logger.debug('Connecting emulators...')
    connectDatabaseEmulator(db, '127.0.0.1', 9000)
    // connectAuthEmulator(auth, 'http://127.0.0.1:9099')

    connectStorageEmulator(getStorage(), '127.0.0.1', 9199)
    connectFunctionsEmulator(functions, '127.0.0.1', 5001)
}
